export function shareLink(shareLink, onSuccess, onError, title) {
  const shareTitle = title || 'Check out this collection!';
  if (navigator.share) {
    navigator
      .share({ title: shareTitle, url: shareLink })
      .then(() => {
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          if (onError) onError(err);
        }
      });
  } else if (navigator.clipboard) {
    navigator.clipboard
      .writeText(shareLink)
      .then(() => {
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        if (onError) onError(err);
      });
  } else {
    if (onError) onError(new Error('Share and clipboard not supported'));
  }
}

export function copyLink(link, onSuccess, onError) {
  if (navigator.clipboard) {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        if (onError) onError(err);
      });
  } else {
    if (onError) onError(new Error('Clipboard not supported'));
  }
}
